import { render } from "./OkSvg.vue?vue&type=template&id=183d1615"
import script from "./OkSvg.vue?vue&type=script&lang=js"
export * from "./OkSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__